import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { log } from "console";
import { Subscription } from "rxjs";
import { HomeComponent } from "src/app/home/home.component";
import { SessionService } from "src/app/services/session.service";
import { ClientDetailsService } from "./client-details.service";

@Component({
  selector: "app-client-details",
  templateUrl: "./client-details.component.html",
  styleUrls: ["./client-details.component.scss"],
})
export class ClientDetailsComponent implements OnInit, OnDestroy {

  reqSubcription: Subscription[] = [];
  userName: any;
  roles: any;
  isButtonClicked = false;

  public userId: any;
  public clients: any = [];
  public processNames: any = []
  public brands: any = [];
  public selectedClient: any = '';
  public selectedClientKey: any = '';
  public selectedProcessName: any = '';
  public selectedBrand: any = '';

  constructor(
    private dialogRef: MatDialogRef<ClientDetailsComponent>,
    private sessionService: SessionService,
    public clientDetailsService: ClientDetailsService,
    public homeComponent: HomeComponent,
  ) {
    dialogRef.disableClose = true;
    this.userName = this.sessionService.getUsername();
  }

  ngOnInit(): void {
    this.getClients();
  }

  getClients() {
    this.clientDetailsService.getClientDetails().subscribe((res: any) => {
      this.clients = res || [];
      let storedClient = JSON.parse(sessionStorage.getItem('client') || 'null');
      if (storedClient) {
        let clientKey = storedClient[0]?.client?.client_key;
        const index = this.clients.findIndex((c: any) => c.client_key === clientKey);
        if (index >= 0) {
          this.selectedClient = this.clients[index];
          this.getBrands(clientKey);
        }
      }
    });
  }

  onClientChange() {
    this.selectedBrand = '';
    this.selectedProcessName = '';
    this.brands = [];
    this.processNames = [];
    this.getBrands(this.selectedClient?.client_key);
  }

  getProcessTypes() {
    this.setEnvVariableOnBrand(this.selectedBrand)
    let processExecutionDetails: any = sessionStorage.getItem('process-management-details');

    setTimeout(() => {
      this.clientDetailsService.getProcessTypes()
        .subscribe((res: any) => {
          if (res) {
            this.processNames = res;
            if (typeof processExecutionDetails === 'string') {
              processExecutionDetails = JSON.parse(processExecutionDetails);
            }
            this.selectedProcessName = processExecutionDetails?.processName;
          }
        })
      this.userId = this.sessionService.getUsername();
    }, 100)
  }

  setEnvVariableOnBrand(selectedBrand: any) {
    const { region_code, region_key, region_name, secret_name_db } = selectedBrand
    let value = { region_code, region_key, region_name, secret_name_db };
    this.sessionService.setStoreData('envHeaderVariables', value);
    this.sessionService.setEnvSessionVariable(selectedBrand);
  }

  // getClientDetails() {
  //   this.clientDetailsService.getClientDetails().subscribe((res: any) => {
  //     this.clients = res;
  //   })
  // }

  getBrands(clientKey: any) {
    this.clientDetailsService.getAllBrand(clientKey).subscribe((res: any) => {
      this.brands = res;
      if (res) {
        let userPreferredBrand = this.sessionService.getSelectedKey("selectedBrand");
        if (userPreferredBrand) {
          const index = this.brands.findIndex((o: any) => o.brand_key === userPreferredBrand.brand_key);
          this.selectedBrand = this.brands[index] || '';
          if (index >= 0) this.getProcessTypes();
        }
      }
    });
  }


  clientSelection() {
    let clientDetails = {
      client_key: this.selectedClient?.client_key,
      brand: this.selectedBrand,
      processName: this.selectedProcessName,
    }
    this.dialogRef.close(clientDetails);
  }

  compareProcess(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.process_type_key === o2.process_type_key : o1 === o2;
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe());
  }
}
